import { Component, Input, ViewEncapsulation, forwardRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-increment-input',
  templateUrl: './increment-input.component.html',
  styleUrls: ['./increment-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncrementInputComponent),
      multi: true
    }
  ]
})
export class IncrementInputComponent implements ControlValueAccessor {
  /**
   * Input  of increment input component
   */
  @Input() step = 1;
  /**
   * Input  of increment input component
   */
  @Input() min = 0;
  /**
   * Input  of increment input component
   */
  @Input() max = Infinity;
  /**
   * Input  of increment input component
   */
  @Input() wrap = false;
  /**
   * Input  of increment input component
   */
  @Input() color = 'default';
  /**
   * Input  of increment input component
   */
  @Input() symbol = '';
  /**
   * Output  of increment input component
   */
  @Output() changeIncrement: EventEmitter<number> = new EventEmitter<number>();
  /**
   * Value  of increment input component
   */
  value = 0;
  /**
   * Value symbol of increment input component
   */
  valueSymbol = `0${this.symbol}`;
  /**
   * Determines whether disabled is
   */
  isDisabled: boolean;
  /**
   * Determines whether change on
   */
  onChange = (_: any) => { };
  /**
   * Determines whether touch on
   */
  onTouch = () => { };
  /**
   * Increments value
   * @param [step] number
   */
  onClickIncrementValue(step: number = 1): void {
    let inputValue: number = this.value + step;
    if (this.wrap) {
      inputValue = this.wrappedValue(inputValue);
    }
    this.onInput(inputValue);
  }
  /**
   * Should disable decrement
   * @param inputValue number
   * @returns true if disable decrement
   */
  shouldDisableDecrement(inputValue: number): boolean {
    if (this.isDisabled) {
      return true;
    }
    return !this.wrap && inputValue <= this.min;
  }
  /**
   * Should disable increment
   * @param inputValue number
   * @returns true if disable increment
   */
  shouldDisableIncrement(inputValue: number): boolean {
    if (this.isDisabled) {
      return true;
    }
    return !this.wrap && inputValue >= this.max;
  }
  /**
   * Determines whether input on
   * @param value number
   */
  onInput(value: any) {
    this.value = Number(value);
    this.valueSymbol = `${this.value}${this.symbol}`;
    this.onTouch();
    this.onChange(this.value);
    this.changeIncrement.emit(this.value);
  }
  /**
   * Writes value
   * @param value number
   */
  writeValue(value: number): void {
    this.value = value || 0;
    this.valueSymbol = `${this.value}${this.symbol}`;
  }
  /**
   * Registers on change
   * @param fn any
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  /**
   * Registers on touched
   * @param fn any
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  /**
   * Sets disabled state
   * @param isDisabled boolean
   */
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  /**
   * Wrapped value
   * @param inputValue number
   * @returns value number
   */
  private wrappedValue(inputValue: number): number {
    if (inputValue > this.max) {
      return this.min + inputValue - this.max;
    }
    if (inputValue <= this.min) {
      if (this.max === Infinity) {
        return 0;
      }
      return this.max + inputValue;
    }
    return inputValue;
  }
}
